import * as server from '../entries/pages/(app)/_layout.server.ts.js';

export const index = 2;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/pages/(app)/_layout.svelte.js')).default;
export { server };
export const server_id = "src/routes/(app)/+layout.server.ts";
export const imports = ["_app/immutable/nodes/2.Dmx3T-Fg.js","_app/immutable/chunks/disclose-version.jfViFEmK.js","_app/immutable/chunks/index-client.D5Wu0e6C.js","_app/immutable/chunks/legacy.D7Ty_rE8.js","_app/immutable/chunks/attributes.CrWEHQct.js","_app/immutable/chunks/events.BvXFbFGG.js","_app/immutable/chunks/SmuiElement.CmvsvBfp.js","_app/immutable/chunks/if.DrQR4QvV.js","_app/immutable/chunks/actions.Cpbaoh9g.js","_app/immutable/chunks/props.VJg8awrB.js","_app/immutable/chunks/ClassAdder.U4yS4cQf.js","_app/immutable/chunks/svelte-component.xAqTN26e.js"];
export const stylesheets = [];
export const fonts = [];
